import type { FolderPermissionsStore } from './schema/FolderPermissionsStore';
import { createStore } from 'owa-satcheljs';

/**
 * Selector to get UI store for folder permissions package
 */

export const getStore: () => FolderPermissionsStore = createStore<FolderPermissionsStore>(
    'folderPermissionsStore',
    {
        folderId: null,
        permissions: [],
        selectedPermissionIndex: 0,
        showAddUserDialog: false,
        showFolderPermissionsDialog: false,
        showLoader: false,
        shouldDisablePermissions: false,
        shouldDisableAddPermissions: false,
        parentFolderIds: [],

        // Allow parent access dialog state
        showAllowParentAccessDialog: false,
        allowParentAccessDialogState: null,
    }
);
